import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const defaultValues: ContactSupportForm = {
  subject: '',
  message: '',
  name: '',
  email: '',
};

const schema = z.object({
  subject: z.string().min(1, 'Subject is required!'),
  message: z.string().min(1, 'Message is required!'),
  name: z.string().min(1, 'Name is required!'),
  email: z.email('Invalid email address!'),
});

function useContactSupportForm(values?: ContactSupportForm) {
  return useForm({ defaultValues: values ? values : defaultValues, resolver: zodResolver(schema) });
}

export default useContactSupportForm;
